import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Ban, CheckCircle2, FlaskConical, XCircle } from "lucide-react";
import { api, errMsg, ghs } from "../../lib/api";
import { FullLoader } from "../../components/site/Guards";
import { EmptyState } from "../../components/site/Bits";

export default function MockCheckout() {
  const { ref } = useParams();
  const nav = useNavigate();
  const [tx, setTx] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/payments/${ref}`).then((r) => setTx(r.data)).catch(() => setErr(true)); }, [ref]);

  const finish = async (outcome) => {
    try {
      if (outcome === "cancelled") await api.post(`/payments/${ref}/cancel`);
      else await api.post(`/payments/${ref}/mock-complete`, { outcome });
      nav(`/payment/callback?transaction_id=${ref}`, { replace: true });
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (err) return <EmptyState title="Payment not found" text="This test checkout link is invalid." />;
  if (!tx) return <FullLoader />;

  return (
    <div className="mx-auto max-w-md">
      <div className="card-rx overflow-hidden" data-testid="mock-checkout">
        <div className="flex items-center gap-2 border-b border-white/[0.06] bg-amber-500/10 px-6 py-3 text-xs font-semibold uppercase tracking-wider text-amber-300">
          <FlaskConical size={14} /> theteller test checkout (simulated)
        </div>
        <div className="p-7 text-center">
          <p className="text-sm text-slate-400">{tx.item_name}</p>
          <p className="mt-2 font-mono-rx text-4xl font-semibold text-white" data-testid="mock-amount">{ghs(tx.amount_minor)}</p>
          <p className="mt-2 font-mono-rx text-xs text-slate-500">Ref {tx.reference}</p>
          <div className="mt-8 grid gap-3">
            <button onClick={() => finish("success")} className="btn-primary" data-testid="mock-approve-btn"><CheckCircle2 size={16} /> Approve payment</button>
            <button onClick={() => finish("failed")} className="btn-ghost text-red-300" data-testid="mock-decline-btn"><XCircle size={16} /> Decline payment</button>
            <button onClick={() => finish("cancelled")} className="btn-ghost" data-testid="mock-cancel-btn"><Ban size={16} /> Cancel</button>
          </div>
          <p className="mt-6 text-xs leading-relaxed text-slate-500">This page only appears while TELLER_MODE is "mock". With real credentials, customers are sent to theteller's hosted checkout instead.</p>
        </div>
      </div>
    </div>
  );
}
